import $ from 'jquery';
import * as elementTrackingService from '../../Services/elementTracking';

export default {
    init: function enteringScreenElement() {
        $('.js-elementViewedEvent').each((n, elem) => {
            elementTrackingService.publishEnterViewportForElement(elem);
        });
    },
};
